import { render } from "./SimpleBrandCTA.vue?vue&type=template&id=2096f8f8"
import script from "./SimpleBrandCTA.vue?vue&type=script&lang=js"
export * from "./SimpleBrandCTA.vue?vue&type=script&lang=js"
script.render = render

export default script